angular.module('callX').service('UserService', ['$http', '$rootScope', '$location', '$timeout', '$state', 'toaster',
  function ($http, $rootScope, $location, $timeout, $state, toaster){

    var checkingAuthWithServer = false;
    var isUserAuthenticated = false;
    var currentUserData = {};
    var currentServerDetails = {};

    $rootScope.showMainLoader = false;
    

    var updateLeadField = function (data,callbacks) {
      $http.put('/wapi/agent/lead/macros/update',data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var postAgentActions = function (data,optId,scriptId, callbacks) {
      $http.post('/wapi/createscriptanswers/'+scriptId+'/'+optId,data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };
    
    var putAgentTransferStatus = function (userAgentId,callId,callbacks) {
    //  $http.put('/wapi/agent/call/transfer/'+userAgentId)
    $http.put('/wapi/agent/call/transfer/'+userAgentId+'/'+callId)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var postStaticQuestions = function (payload,callbacks) {
      $http.post('/wapi/salesagent/contacts/questions', payload)
            .success(function (data, status) {
              if(callbacks !== undefined) { callbacks.success(data, status); }
            })
            .error(function (data, status) {
              if(callbacks !== undefined) { callbacks.success(data, status); }
            });
      };

      var notesUpdate = function (phonenumber, id, notes, callbacks) {
        var encodedNotes = encodeURIComponent(notes);
        $http.post('/wapi/contact/notes/update?phonenumber=' + phonenumber +'&salesagentid='+ id + '&notes=' + encodedNotes , callbacks)
              .success(function (data, status) {
                if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                if(callbacks !== undefined) { callbacks.success(data, status); }
              });
        };

//added - dispositions -start

    var postDispositions = function (callid,disposition,callbacks) {
    $http.post('/wapi/agent/feedback?callId='+callid+"&disposition="+disposition)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };
//added - dispositions -endP

//added sales disposition start 
 var postsalesDispositions = function (callerid,id,root_disposition,selected_disposition,notes,callbacks) {
  var data = {
    "caller_id":callerid,
    "sales_agent_id":id,
    "root_disposition":root_disposition,
    "disposition":selected_disposition,
    "notes": notes 
  };
  $http.post('/wapi/salesagent/feedback/',data,     
    {transformResponse: [function (data, headersGetter) {
          return data;
        }]} )
        .success(function (data, status) {
          if(callbacks !== undefined) { callbacks.success(data, status); }
        })
        .error(function (data, status) {
          if(callbacks !== undefined) { callbacks.success(data, status); }
        });
  };

  var postetlDispostionStatus = function (id,callerid,rootDispostion,disposition,callbacks) {
    var data = {
      "id":id,
      "caller_id":callerid,
      "root_disposition":rootDispostion,
      "disposition":disposition
    }
    $http
      .put(
        "/etl/conversions/disposition/update/" + id + "/" + callerid + "/" + rootDispostion + "/" + disposition , data
      )
      .success(function (data, status) {
        if (callbacks !== undefined) {
          callbacks.success(data, status);
        }
      })
      .error(function (data, status) {
        if (callbacks !== undefined) {
          callbacks.success(data, status);
        }
      });
  };

  var postetlOldDispostionStatus = function (id,callerid,oldStatus,rootDispostion,disposition,callbacks) {
    var data = {
      "id":id,
      "caller_id":callerid,
      "root_disposition":rootDispostion,
      "disposition":disposition
    }
    $http
      .put(
        "/etl/conversions/disposition/update/" + id + "/" + callerid + "/" + oldStatus + "/" + rootDispostion + "/" + disposition , data
      )
      .success(function (data, status) {
        if (callbacks !== undefined) {
          callbacks.success(data, status);
        }
      })
      .error(function (data, status) {
        if (callbacks !== undefined) {
          callbacks.success(data, status);
        }
      });
  };
//added sales disposition end

    var getDashboardDetails = function (id,role,callbacks) {
      $http.get('/wapi/agent/dashboard?id='+id + '&role=' + role)
          .success(function (data, status) {
            if(callbacks !== undefined) {
               callbacks.success(data, status); 
              }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

     //salesagent Dashboard start
    var getSalesDashboardDetails = function (id, role, callbacks) {
      var reqParams = {
        params: {
          id: id,
          role: role
        }
      };
      $http.get('/wapi/salesagent/dashboard', reqParams)
        .success(function (data, status) {
          if (callbacks !== undefined && callbacks.success !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function (data, status) {
          if (callbacks !== undefined && callbacks.error !== undefined) {
            callbacks.error(data, status);
          }
        });
    };
    //salesagent dashboard end 

    // on end call hit api start
    var onEndCall = function (agentId,callbacks) {
      console.log(agentId, "get id ")
      $http.post('/webrtc/salesagent/paused/'+ agentId)
          .success(function (data, status) {
            if(callbacks !== undefined) { 
              callbacks.success(data, status);
             }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };
    // on end call hit api end

    var getStateCity = function (zipcode,callbacks) {
      $http.get('/wapi/zipcode/state/'+ zipcode)
          .success(function (data, status) {
            if(callbacks !== undefined) { 
              callbacks.success(data, status);
             }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var postAgentStatusUpdate = function (data,userAgentId,role,callbacks) {
      $http.post('/wapi/agent/status/'+userAgentId + '/'+ role ,data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getAgentStatus = function (userAgentId,role,callbacks) {
      $http.get('/wapi/agent/status/'+userAgentId + '/' + role)
          .success(function (data, status) {
            if(callbacks !== undefined) { 
              callbacks.success(data, status);
            }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var postAgentBusy = function (data,userAgentId,callbacks) {
      $http.post('/wapi/agent/call/status/'+userAgentId,data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var postAgentAvailable = function (data,userAgentId,callbacks) {
      $http.post('/wapi/agent/call/status/'+userAgentId,data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getUserDetails = function (data, role, callbacks) {
      $http.get('/wapi/agent/lead/details?phonenumber='+data + '&role='+ role)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    //salesuser details start
    var getSalesUserDetails = function (data, agentId, callbacks) {
      $http.get('/wapi/salesagent/contact/details?phonenumber='+data +'&salesagentid='+ agentId)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };
    //sales details end

    //repeatedly hitting server to check net connectivity -start

     var postConnectionDetails = function (userAgentId,role,callbacks) {
      $http.post('/wapi/agent/agentinternetstatus/'+userAgentId + '/' + role)
          .success(function (data, status) {
            if(callbacks !== undefined) { 
              callbacks.success(data, status);
             }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };  
   
    //repeatedly hitting server to check net connectivity -end

    var getIVRDetails = function (data, agentId, callbacks) {
      $http.get('/wapi/ivrdetails?phonenumber='+data+"&agentId="+agentId)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getOfferTransfer = function (offerId,callId,dId,callbacks) {
      $http.get("/webrtc/transfercall?offerid="+offerId+"&callid="+callId+"&destinationid="+dId)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };
    var getOfferDetailsFinal = function (id,callid,state,campaignid,callbacks) {
      $http.get("/wapi/offerdetails?callid="+callid+"&state="+state+"&campaignid="+campaignid+"&filterid="+id)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };
    
    var postUserDetails = function (data,callbacks) {
      $http.put("/wapi/agent/lead/details",data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getCallHistory = function (id,role,pageno,size,callbacks) {
       $http.get("/wapi/callhistory?agentId="+id+"&role="+ role+"&page=" + pageno + "&size=" + size)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getContactsPage = function (id,pageno,size,callbacks) {
      $http.get("/wapi/salesagent/contacts/list?salesAgentId="+ id + "&page=" + pageno + "&size=" + size)
         .success(function (data, status) {
           if(callbacks !== undefined) { callbacks.success(data, status); }
         })
         .error(function (data, status) {
           if(callbacks !== undefined) { callbacks.success(data, status); }
         });
   };

   var getContactsDetailsView = function (phoneNumber,id,callbacks) {
      $http.get("/wapi/salesagent/contact/view?phonenumber="+ phoneNumber + '&salesAgentId=' + id)
        .success(function (data, status) {
          if(callbacks !== undefined) { callbacks.success(data, status); }
        })
        .error(function (data, status) {
          if(callbacks !== undefined) { callbacks.success(data, status); }
        });
    };

    var updateContactDetailsView = function (data,callbacks) {
      $http.put("/wapi/salesagent/contact/details", data)
        .success(function (data, status) {
          if(callbacks !== undefined) { callbacks.success(data, status); }
        })
        .error(function (data, status) {
          if(callbacks !== undefined) { callbacks.success(data, status); }
        });
    };



//added-start   
    var getForwardOfferData = function (data,optId,scriptId, callbacks) {   
      $http.post('/wapi/createscriptanswers/'+scriptId+'/'+optId,data)    
        .success(function (data, status) {    
            if(callbacks !== undefined) { callbacks.success(data, status); console.log("userservice");}   
          })    
          .error(function (data, status) {    
            if(callbacks !== undefined) { callbacks.success(data, status); }    
          });   
    };    
    var postSelectedOfferFrwd=function(offerId,callId,callbacks){   
       $http.post('/webrtc/singleoffer/forward?callId='+callId+'&offerId='+offerId)   
       .success(function (data, status) {   
            if(callbacks !== undefined) { callbacks.success(data, status);}   
          })    
          .error(function (data, status) {    
            if(callbacks !== undefined) { callbacks.success(data, status); }    
          });   
    }   
//added-end

//editscript-added-start
var saveSideQustns = function (data, callbacks) {
         $http.post('/wapi/updatescriptquestion', data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };
//editscript-added-end

    var getAlertsData = function (id,callbacks) {
      $http.get("/japi/user-alert/"+id)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };
    
    var putAlertsData = function (notificationAlert,emailAlert,callbacks){
      var total = {
        "id":1,
        "email_alert":emailAlert,
        "notification_alert":notificationAlert
      };
      $http.put("/japi/user-alert",total)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var checkWhetherAreRoutesAuthenticated = function (event) {
      if (isUserAuthenticated == false) {
        clearSession()
        if (($location.path()!="/access/login")&&($location.path()!="/app/agent")) {
          $location.path("access/login");
        }
      } else{
        if (($location.path()=="/access/login")) {
          var username = window.localStorage.getItem("user_name")
          var userid = window.localStorage.getItem("user_id")
          var firstname = window.localStorage.getItem("first_name")
          var lastname = window.localStorage.getItem("last_name")
          var showvalue = window.localStorage.getItem("show_value")
          var callhistory = window.localStorage.getItem("call_history")
          var role = window.localStorage.getItem('role');
          if(username !== null && userid !== null && role == 'useragent') {
              $state.go('app.agent.dashboard',{'username':username,'userId':userid, 'first_name': firstname, 'last_name': lastname, 'show_value':showvalue, 'call_history':callhistory});
          }
          else if(username !== null && userid !== null && role == 'salesagent') {
            $state.go('app.sales-agent',{'username':username,'userId':userid, 'first_name': firstname, 'last_name': lastname, 'show_value':showvalue, 'call_history':callhistory});
          }
        }
      }
      $timeout(function(){
        $rootScope.showMainLoader = false;
        $rootScope.httpInterceptorInProgress = false;
      },30)
    };

    var decodeJwt = function (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(escape(window.atob(base64)));
      return JSON.parse(jsonPayload);
   }

   function trySetClarityTags(userData, attempts) {
     // Check if clarity exists
     if (typeof window !== 'undefined' && typeof window.clarity === 'function') {
       console.log('clarity found, setting tags', clarity);
       setClarityTags(userData);
     } else if (attempts > 0) {
      //  console.log('clarity not found, retrying...', attempts, 'attempts left');
       setTimeout(function() {
         trySetClarityTags(userData, attempts - 1);
       }, 500); // retry every 500ms
     }
   }
   
   function setClarityTags(userData) {
     // Set Microsoft Clarity custom tags
     if (userData) {
       // Set user-specific tags for better analytics tracking
       if (userData.email) {
         clarity("set", "user_email", userData.email);
       }
       if (userData.fullName) {
         clarity("set", "username", userData.fullName);
       }
       if (userData.userId) {
         clarity("set", "user_id", userData.userId);
       }
       // You can add more custom tags as needed
     }
   }


    var checkUserSessionWithServer = function(){
      checkingAuthWithServer = true;
      var user_id = window.localStorage.getItem("user_id");
      // var role =  window.localStorage.getItem("role");
      // console.log("checkuserserver role",role);
      if(user_id == null) {
        clearSession()
        return;
      } else {

        var token =   window.localStorage.getItem('access_token');

        if (token) {          
          // var payload = decodeJwt(token);
          // var currentTime = Math.floor(Date.now() / 1000);
          // console.log('currentTime:', currentTime);
          // console.log('token exp:', payload.exp);
          // console.log('currentTime > payload.exp:', currentTime > payload.exp);
          isUserAuthenticated = true;
          currentUserData = getUserData(token)
          var user_id =   window.localStorage.getItem('user_id');
          currentUserData.userId = user_id;
          $rootScope.$broadcast('currentUserUpdate', currentUserData);
          trySetClarityTags(currentUserData, 5);
          checkingAuthWithServer = false;
          checkWhetherAreRoutesAuthenticated();
        } else {
          checkingAuthWithServer = false;
          isUserAuthenticated = false;
          checkWhetherAreRoutesAuthenticated();
        }

        
        // $http.get("/wapi/agent/"+user_id )
        //     .success(function (data, status) {
        //       if ( data.statusCode == 200 ) {
        //         isUserAuthenticated = true;
        //       }
        //       currentUserData = data.data;
        //       $rootScope.$broadcast('currentUserUpdate', currentUserData);
        //       checkingAuthWithServer = false;
        //       checkWhetherAreRoutesAuthenticated();
        //       // if(data.data.type != 'admin'){
        //       //   userLogout(data.data.user_id);
        //       // }
        //     })
        //     .error(function (data, status) {
        //       checkingAuthWithServer = false;
        //       isUserAuthenticated = false;
        //       checkWhetherAreRoutesAuthenticated();
        //     });
      }
    };

    //   var checkServerName = function(){
    //       $http.get("/japi/servername")
    //           .success(function (data, status) {
    //               currentServerDetails = data;
    //               $rootScope.$broadcast('currentServerUpdate', currentServerDetails);
    //           })
    //           .error(function (data, status) {

    //           });
    //   };

    var updateUserPassword = function (id, data, callbacks) {
      $http.put("/japi/forgot-password/"+id, data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getEmailTemplate = function (id, callbacks) {
      $http.get("/japi/email-template/"+id)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var updateUserAccount = function (id, data, callbacks) {
      $http.put("/wapi/agent/"+id, data)
          .success(function (data, status) {
            checkUserSessionWithServer();
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getEmailTemplatesData = function (callbacks) {
      $http.get("/japi/email-template")
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var updateEmailTemplateData = function (id,data,callbacks) {
      $http.put("/japi/email-template/"+id, data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

      function decodeJWT(token) {
        if (!token) return null;

        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(escape(window.atob(base64)));
        return JSON.parse(jsonPayload);
    }

    function storeTokensAndUserData(access_token, refresh_token, userId, userName) {
      var decodedToken = decodeJWT(access_token);
  
      if (decodedToken) {
          var firstName = decodedToken.given_name;
          var lastName = decodedToken.family_name;
          var userId = userId;
          var userName = userName;
          var agentName = decodedToken.name;
          var email = decodedToken.email;

          var roles = decodedToken.realm_access.roles;
          var rolePriority = ["ADMIN", "AGENCY_OWNER", "MANAGER", "AGENT", "USER"];
          var role = "AGENT"; // Default role
    
          for (var i = 0; i < rolePriority.length; i++) {
            if (roles.indexOf(rolePriority[i]) !== -1) {
              role = rolePriority[i];
              role = role === 'ADMIN' ? 'admin' : role;
              break;
            }
          }

          window.localStorage.setItem('first_name', firstName);
          window.localStorage.setItem('last_name', lastName);
          window.localStorage.setItem('user_id', userId);
          window.localStorage.setItem('user_name', userName);
          window.localStorage.setItem('email', email);
          window.localStorage.setItem('role', role);
          window.localStorage.setItem('show_value', true);
          window.localStorage.setItem('call_history', true);
  
          window.localStorage.setItem('access_token', access_token);
          window.localStorage.setItem('refresh_token', refresh_token);
      } else {
          console.error('Invalid access token');
      }
    }
    
    function getUserData(token) {
      var decodedToken = decodeJWT(token);

      var firstName = decodedToken.given_name;
      var lastName = decodedToken.family_name;
      var agentUuid = decodedToken.sub;
      var fullName = decodedToken.name;
      var email = decodedToken.email;

      var roles = decodedToken.realm_access.roles;
      var rolePriority = ["ADMIN", "AGENCY_OWNER", "MANAGER", "AGENT"];
      var role = "AGENT"; // Default role

      for (var i = 0; i < rolePriority.length; i++) {
        if (roles.indexOf(rolePriority[i]) !== -1) {
          role = rolePriority[i];
          break;
        }
      }
  
      if (fullName && email && agentUuid) {
          return {
              fullName: fullName,
              email: email,
              agentUuid: agentUuid,
              firstName: firstName,
              lastName: lastName,
              role: role,
          };
      } else {
          console.error('User data is incomplete or missing in localStorage.');
          return null;
      }
  }

  var agentLogin = function (userData, data, callbacks) {
    $http
    .get("/v1/salesagent/find", {
      params: { email: userData.email },
      headers: {
        "Authorization": "Bearer " + data.access_token
      }
    })
    .success(function (agentResponse, status) {
      console.log('agentResponse',agentResponse)
      if (agentResponse && agentResponse.id) {
        window.localStorage.setItem('user_details', JSON.stringify(agentResponse));

        userData.userId = agentResponse.id
        userData.username = agentResponse.sipUserName

        storeTokensAndUserData(data.access_token, data.refresh_token, userData.userId, userData.username);
        trySetClarityTags(userData, 5);
        isUserAuthenticated = true;
        $rootScope.$broadcast(
          "loginSuccessfulUpdate",
          isUserAuthenticated
        );

        // var logMessage =
        //   "Event: Login | Agent Id: " +
        //   userData.userId +
        //   " | Date: " +
        //   new Date().toLocaleString("en-US", {
        //     timeZone: "UTC",
        //     hour12: false,
        //   });
        // Sentry.captureMessage(logMessage, {
        //   level: "log",
        //   fingerprint: ["unique-event-" + Date.now()],
        // });     

        if (typeof clarity === "function") {
          clarity("set", "email", userData.email);
          clarity("set", "username", userData.username);
          clarity("set", "userId", userData.userId);
        } else {
          console.warn("Clarity is not initialized yet.");
        }

        // **Make an additional API call to fetch the agentId**
        var getstatus = true;
        var getCallHistory = true;
        console.log("Updated userData with userId:", userData.userId);

        // Redirect based on role
        if (userData.role === "useragent") {
          console.log("if useragent");
          $state.go("app.agent.dashboard", {
            username: userData.username,
            userId: userData.userId,
            first_name: userData.firstName,
            last_name: userData.lastName,
            role: userData.role,
            email: userData.email,
            show_value: getstatus,
            call_history: getCallHistory,
          });
        } else if (userData.role === "AGENT") {
          console.log("if salesagent");
          $state.go("app.sales-agent", {
            username: userData.username,
            userId: userData.userId,
            first_name: userData.firstName,
            last_name: userData.lastName,
            role: userData.role,
            email: userData.email,
            show_value: getstatus,
            call_history: getCallHistory,
          });
        }

        if (callbacks !== undefined) {
          callbacks.success(userData, status);
        }
      } else {
        console.error("Agent ID not found in response:", agentResponse);
        toaster.pop("error", "Error", "Failed to retrieve Agent ID.");
      }
    })
    .error(function (errorResponse, status) {
      console.error("Failed to fetch userId:", errorResponse);
      toaster.pop("error", "Error", "Failed to fetch Agent ID.");
      if (callbacks !== undefined) {
        callbacks.success(userData, status);
      }
    });
  }

  var managerLogin = function (userData, data, callbacks) {
    $http
    .get("/v1/managers/find", {
      params: { email: userData.email },
      headers: {
        "Authorization": "Bearer " + data.access_token
      }
    })
    .success(function (response, status) {
      if (response && response.uuid) {
        window.localStorage.removeItem('impersonation_access_token');
        window.localStorage.removeItem('impersonation_refresh_token');
        window.localStorage.removeItem('impersonation_role');

        window.localStorage.setItem('user_details', JSON.stringify(response));
        userData.userId = response.uuid
        userData.username = response.firstName + ' ' + response.lastName

        storeTokensAndUserData(data.access_token, data.refresh_token, userData.userId, userData.username);
        var baseUrl = window.location.origin; // Get the current base URL dynamically
        var url = baseUrl + "/v2/manager/agents";
        window.location.href = url; 

        if (callbacks !== undefined) {
          callbacks.success(userData, status);
        }
      } else {
        console.error("Manager ID not found in response:", response);
        toaster.pop("error", "Error", "Failed to retrieve Manager ID.");
      }
    })
    .error(function (errorResponse, status) {
      clearSession();
      console.error("Failed to fetch userId:", errorResponse);
      toaster.pop("error", "Error", "Failed to fetch Agent ID.");
      if (callbacks !== undefined) {
        callbacks.error(userData, status);
      }
    });
  }

  var agencyOwnerLogin = function (userData, data, callbacks) {
    $http
    .get("/v1/agency-owners/find", {
      params: { email: userData.email },
      headers: {
        "Authorization": "Bearer " + data.access_token
      }
    })
    .success(function (response, status) {
      if (response && response.uuid) {
        window.localStorage.removeItem('impersonation_access_token');
        window.localStorage.removeItem('impersonation_refresh_token');
        window.localStorage.removeItem('impersonation_role');
        window.localStorage.setItem('user_details', JSON.stringify(response));

        userData.userId = response.uuid
        userData.username = response.firstName + ' ' + response.lastName

        storeTokensAndUserData(data.access_token, data.refresh_token, userData.userId, userData.username);
        var baseUrl = window.location.origin; // Get the current base URL dynamically
        var url = baseUrl + "/v2/agency-owner/agents";
        window.location.href = url; 

        if (callbacks !== undefined) {
          callbacks.success(userData, status);
        }
      } else {
        console.error("Manager ID not found in response:", response);
        toaster.pop("error", "Error", "Failed to retrieve Manager ID.");
      }
    })
    .error(function (errorResponse, status) {
      clearSession();
      console.error("Failed to fetch userId:", errorResponse);
      toaster.pop("error", "Error", "Failed to fetch Agent ID.");
      if (callbacks !== undefined) {
        callbacks.error(userData, status);
      }
    });
  }

  var adminLogin = function (userData, data, callbacks) {
    $http
    .get("/japi/user/0", {
      params: { email: userData.email },
      headers: {
        "Authorization": "Bearer " + data.access_token
      }
    })
    .success(function (response, status) {
      if (response && response.data) {
        window.localStorage.setItem('user_details', JSON.stringify(response.data));

        userData.userId = response.data.id
        userData.username = response.data.first_name + ' ' + response.data.last_name

        storeTokensAndUserData(data.access_token, data.refresh_token, userData.userId, userData.username);
        var adminBaseUrl = window.location.origin;
        var dataToSend = {};
        
        // Store all localStorage items in dataToSend
        for (var i = 0; i < localStorage.length; i++) {
          var key = localStorage.key(i);
          dataToSend[key] = localStorage.getItem(key);
        }
        
        var jsonData = JSON.stringify(dataToSend);
        var encodedData = encodeURIComponent(jsonData);
        window.localStorage.clear();

        if (adminBaseUrl.includes('localhost')) {
          adminBaseUrl = 'http://localhost';
        } else if (adminBaseUrl.includes('contact.callx.com')) {
          adminBaseUrl = 'https://admin.callx.com';
        } else {
          adminBaseUrl = 'https://admin.staging.callxdev.com';
        }
      
        var adminUrl = adminBaseUrl + "/#/app/agents/agentslist?impersonate=user#" + encodedData;
        window.location.href = adminUrl;

        if (callbacks !== undefined) {
          callbacks.success(userData, status);
        }
      } else {
        console.error("Admin ID not found in response:", response);
        toaster.pop("error", "Error", "Failed to retrieve Admin ID.");
      }
    })
    .error(function (errorResponse, status) {
      clearSession();
      console.error("Failed to fetch userId:", errorResponse);
      toaster.pop("error", "Error", "Failed to fetch Agent ID.");
      if (callbacks !== undefined) {
        callbacks.error(userData, status);
      }
    });
  }

  var userSignIn = function (data, callbacks) {
    var credentials = {
      grantType: "password",
      clientId: "PUBLIC_CLIENT",
      email: data.email,
      password: data.password,
    };

    var loginStartTime = performance.now();

    $http
      .post("/auth/token", credentials)
      .success(function (data, status) {

        var duration = performance.now() - loginStartTime;
        duration = duration.toFixed(2);
        
        if (status === 200) {
          // if (duration > 1000) {
            //     var logMessage = "API Performance: Login Success | Duration: " + duration + "ms | Agent Id: " + userData.agentId + " | Date: " + new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: false });
            //     Sentry.captureMessage(logMessage, { level: "info" });
            //     console.log(logMessage);
            // }
            
            var userData = getUserData(data.access_token);
            if(userData.role.includes('AGENT')) {
              agentLogin(userData, data,callbacks)
            }
            if(userData.role.includes('MANAGER')) {
              managerLogin(userData, data, callbacks)
            }
            if(userData.role.includes('AGENCY_OWNER')) {
              agencyOwnerLogin(userData, data, callbacks)
            }
        }
      })
      .error(function (data, status) {
        var duration = performance.now() - loginStartTime;
        duration = duration.toFixed(2);

        if (duration > 1000) {
          var logMessage =
            "API Performance: Login Failed | Duration: " +
            duration +
            "ms | Date: " +
            new Date().toLocaleString("en-US", {
              timeZone: "UTC",
              hour12: false,
            });
          // Sentry.captureMessage(logMessage, { level: "info" });
          console.log(logMessage);
        }

        if (data.data === "Invalid Credentials : User is NOT in active state") {
          toaster.pop("error", "Error", "Your account is not active");
        } else {
          toaster.pop("error", "Error", "Invalid Credentials");
        }

        if (callbacks !== undefined) {
          callbacks.success(data, status);
        }
      });
  };


  var exitImpersonation = function (role, callbacks) {
    // Retrieve impersonation tokens once
    var accessToken = window.localStorage.getItem('impersonation_access_token');
    var refreshToken = window.localStorage.getItem('impersonation_refresh_token');

    // Restore tokens if present
    if (accessToken && refreshToken) {
      window.localStorage.setItem('access_token', accessToken);
      window.localStorage.setItem('refresh_token', refreshToken);
    }

    // Get user data only if needed
    if (role === 'MANAGER' || role === 'AGENCY_OWNER') {
      var userData = getUserData(accessToken);
      var data = { access_token: accessToken, refresh_token: refreshToken };
      if (role === 'MANAGER') {
        managerLogin(userData, data, callbacks);
      } else {
        agencyOwnerLogin(userData, data, callbacks);
      }
    } else if (role === 'ADMIN') {
      // Determine base URL
      var baseUrl = window.location.origin;
      if (baseUrl.indexOf('localhost') !== -1) {
        baseUrl = 'http://localhost';
      } else if (baseUrl.indexOf('contact.callx.com') !== -1) {
        baseUrl = 'https://admin.callx.com';
      } else {
        baseUrl = 'https://admin.staging.callxdev.com';
      }
      
      var path = '/#/app/agents/agentslist';
      
      var url = baseUrl + path;
      window.localStorage.clear();
      window.location.href = url;
    }
  };


    var forgotPassword = function (data, callbacks) {
      $http.post('/japi/forgot-password', data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var clearSession = function () {
      isUserAuthenticated = false;
      // if(currentUserData.id) {
      //   logMessage = "Event: Session Cleared | Agent Id: " + currentUserData.id + " | Date: " + new Date().toLocaleTimeString().slice(0, 8);
      //   Sentry.captureMessage(logMessage, {
      //     fingerprint: ["unique-event-" + Date.now()]
      //   });
      // }
      currentUserData = {};
      $rootScope.$broadcast('currentUserUpdate', currentUserData);
      $rootScope.$broadcast('logoutSuccessfulUpdate', isUserAuthenticated);
      window.localStorage.removeItem('first_name');
      window.localStorage.removeItem('last_name');
      window.localStorage.removeItem('user_id');
      window.localStorage.removeItem('user_name');
      window.localStorage.removeItem('show_value')
      window.localStorage.removeItem('call_history')
      window.localStorage.removeItem('switchStatus');
      window.localStorage.removeItem('access_token');
      window.localStorage.removeItem('refresh_token');
      window.localStorage.removeItem('user_details');
      window.localStorage.clear()
      if ($rootScope.socket && ($rootScope.socket.readyState != 2 || $rootScope.socket.readyState != 3)) {
        $rootScope.socket.close()
      }
      if ($rootScope.plivoWebSdk) {
            $rootScope.plivoWebSdk.client.logout();
      }
      if ($location.path()!="/access/sign-up") {
        $state.go('access.login');
      }
    };

    var agentLogout = function (id,role) {
      $http.delete('/wapi/session/'+id + '/' + role)
          .success(function (data, status) {
          })
          .error(function (data, status) {
          });
    }; 

    var userLogout = function (token, callbacks) {
      // console.log("role from logout",role);
      var userId = localStorage.getItem('user_id');

      agentLogout(userId, 'salesagent')
      $http.post('/auth/logout', { refreshToken: token, clientId: "PUBLIC_CLIENT" })
          .success(function (data, status) {
            if ( status == 204 ) {
              // var logMessage = "Event: Logout | Agent Id: " + id + " | Date: " + new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: false });
              // Sentry.captureMessage(logMessage, {
              //   level: "log",
              //   fingerprint: ["unique-event-" + Date.now()]
              // });
              clearSession();
            }
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
      // $http.delete('/wapi/session/'+id + '/' + role)
      //     .success(function (data, status) {
      //       if ( data.statusCode == 200 ) {
      //         var logMessage = "Event: Logout | Agent Id: " + id + " | Date: " + new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: false });
      //         Sentry.captureMessage(logMessage, {
      //           level: "log",
      //           fingerprint: ["unique-event-" + Date.now()]
      //         });
      //         clearSession();
      //       }
      //       if(callbacks !== undefined) { callbacks.success(data, status); }
      //     })
      //     .error(function (data, status) {
      //       if(callbacks !== undefined) { callbacks.success(data, status); }
      //     });
    }; 

    var signupSalesAgent = function(data, callbacks){
      $http.post("/japi/salesagent/create", data)
      console.log(data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    }; 

    var signupAgent = function(data, callbacks){
      // Get the full URL and extract agencyId
      // var url = window.location.href;
      // var hash = url.split('#')[1] || ''; 
      // var queryString = hash.split('?')[1] || ''; 
      // var params = new URLSearchParams(queryString);
      // var agencyId = params.get('agencyId');
      
      var agencyId = data.agencyId || null;
      // Build the URL with agencyId if it exists
      var apiUrl = "/v1/salesagent/signup";
      if (agencyId) {
        apiUrl += "?agencyId=" + encodeURIComponent(agencyId);
      }
      
      $http.post(apiUrl, data, {
        transformResponse: [function (data, headersGetter) {
          return data;
        }]
      })
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.error(data, status); }
          });
    };

    var signupSalesAgent = function(data, callbacks){
      $http.post("/japi/salesagent/create", data)
      console.log(data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    }; 

    var getAgencyByAgencyId = function(agencyId, callbacks) {
      $http.get('/v1/agencies/info/' + agencyId)
        .success(function(data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function(data, status) {
          if (callbacks !== undefined) {
            callbacks.error(data, status); // Use `error` callback here instead of `success`
          }
        });
    };

    var contactPageReportsData = function (filterscontact, callbacks) {
      $http
        .post("/reports-v2/salesagents/reports", filterscontact)
        .success(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        });
    };

    var callHistoryPageReportsData = function (filtershistory, callbacks) {
      $http
        .post("/reports-v2/salesagents/callhistory/reports", filtershistory)
        .success(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        });
    };

    var stageDispositionSubmit = function (agentId, phone_number, rootDisposition, disposition, callbacks) {
      $http
        .put("/disposition/update/"+ agentId + "/" + phone_number + "/" + rootDisposition + "/" + disposition)
        .success(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        });
    };

    var getCarrierDetails = function (callbacks) {
      $http
        .get("/wapi/carrier/get/criteria", callbacks)
        .success(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        });
    };
    var getCarrierDetailsForFilters = function (callbacks) {
      $http
        .get("/wapi/carrier/get/limited", callbacks)
        .success(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        });
    };

    var getProductsBasedOnCarrier = function (carrierid, callbacks) {
      $http
        .get("wapi/carrierproduct/get/"+carrierid, callbacks)
        .success(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        });
    };

    var getAllProducts = function (callbacks) {
      $http
        .get("wapi/product/get/criteria", callbacks)
        .success(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        });
    };
    var getAllProductsForFilters = function (callbacks) {
      $http
        .get("wapi/product/get/limited", callbacks)
        .success(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        });
    };

    var getAgentDetails = function (callbacks) {
      $http
        .get("/wapi/agent/getAll/criteria", callbacks)
        .success(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        });
    };

    var getAgentDetailsForFilters = function (callbacks) {
      $http
        .get("/wapi/agent/getAll/limited", callbacks)
        .success(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.error(data, status);
          }
        });
    };

    // var getFilterAllAgentDetails = function (callbacks) {
    //   $http
    //     .get("/wapi/agent/get", callbacks)
    //     .success(function (data, status) {
    //       if (callbacks !== undefined) {
    //         callbacks.success(data, status);
    //       }
    //     })
    //     .error(function (data, status) {
    //       if (callbacks !== undefined) {
    //         callbacks.success(data, status);
    //       }
    //     });
    // };

    var getApplicationContactDetails = function (contactid,agentid,callbacks){
      $http
      .get("/wapi/contact/applications/get/" + contactid + "/" + agentid)
      .success(function (data, status) {
        if (callbacks !== undefined) {
          callbacks.success(data, status);
        }
      })
      .error(function (data, status) {
        if (callbacks !== undefined) {
          callbacks.success(data, status);
        }
      });
    }

    var getApplicationDetails = function (agentid, page, size,callbacks){
      $http
      .get("/wapi/applications/get/" + agentid + "?page=" + page + "&size=" + size)
      .success(function (data, status) {
        if (callbacks !== undefined) {
          callbacks.success(data, status);
        }
      })
      .error(function (data, status) {
        if (callbacks !== undefined) {
          callbacks.success(data, status);
        }
      });
    }

    var createApplication = function (data,callbacks){
      $http
      .post("/wapi/applications/create/",data, {transformResponse: [function (data, headersGetter) {
          return data;
        }]} )
      .success(function (data, status) {
        if (callbacks !== undefined) {
          callbacks.success(data, status);
        }
      })
      .error(function (data, status) {
        if (callbacks !== undefined) {
          callbacks.error(data, status);
        }
      });
    } 

    var updateSalesAgent = function(agentId,data, callbacks){
      $http.put("/japi/salesagent/update/"+agentId, data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getSalesAgents = function(id,callbacks){
      $http.get("/japi/salesagent/get/" + id)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
      }; 

      var getAgentTimeZones = function(callbacks){
        $http.get("/japi/timezones")
            .success(function (data, status) {
              if(callbacks !== undefined) { callbacks.success(data, status); }
            })
            .error(function (data, status) {
              if(callbacks !== undefined) { callbacks.success(data, status); }
            });
      };

      var getSupportDetails = function (userId,page, size,callbacks){
        $http
        .get("/wapi/techError/get/"+ userId + "?page=" + page + "&size=" + size)
        .success(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        });
      }

      var createSupport = function (data,callbacks){
        $http({
          method: 'POST',
          url: '/wapi/techError/createOrUpdate/0 ',
          data: data,
          headers: {
              'Content-Type': undefined  // Let the browser set the Content-Type header
          },
          transformRequest: angular.identity  // Prevent AngularJS from serializing the FormData
      })

        .success(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.error(data, status);
          }
        });
      } 

    // update carrier
    var updateSupport = function(ticketId,data, callbacks){
      $http({
        method: 'POST',
        url: '/wapi/techError/createOrUpdate/' + ticketId, 
        data: data,
        headers: {
            'Content-Type': undefined  
        },
        transformRequest: angular.identity 
    })
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };  


    var updateSupportStatus = function (id, status, callbacks){
      $http
      .post("/wapi/techError/status/update/"+ id + "/" + status)

      .success(function (data, status) {
        if (callbacks !== undefined) {
          callbacks.success(data, status);
        }
      })
      .error(function (data, status) {
        if (callbacks !== undefined) {
          callbacks.success(data, status);
        }
      });
    }

      var getSettingsRecords = function (salesagentid,callbacks){
        $http
        .get("/wapi/ghl/simplywork/integration/" + salesagentid)
        // .post("/wapi/ghl/simplywork/integration", _data)
        .success(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        });
      } 

    var settingAppRecord = function (salesagentid, locationid, action, callbacks){
      $http
      .post("/wapi/ghl/simplywork/integration?salesagentid=" + salesagentid  + "&locationid=" + locationid + "&action=" + action)
      // .post("/wapi/ghl/simplywork/integration", _data)
      .success(function (data, status) {
        if (callbacks !== undefined) {
          callbacks.success(data, status);
        }
      })
      .error(function (data, status) {
        if (callbacks !== undefined) {
          callbacks.success(data, status);
        }
      });
    } 

    var applicationPageReportsData = function (filtersapplications, callbacks) {
      $http
        .post("/reports-v2/salesagents/applications/reports", filtersapplications)
        .success(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        })
        .error(function (data, status) {
          if (callbacks !== undefined) {
            callbacks.success(data, status);
          }
        });
    };

    checkUserSessionWithServer();
    //checkServerName();

    $rootScope.$on('clearSession', function(event, dateObj) {
      clearSession();
    });

    return {
       getUserDetails: function (data,role,callbacks) {
        getUserDetails(data,role,callbacks);
      },
      getSalesUserDetails:function(data,agentId,callbacks){
        getSalesUserDetails(data,agentId,callbacks);
      },
      getDashboardDetails: function (id,role,callbacks) {
        getDashboardDetails(id,role,callbacks);
      },
      getSalesDashboardDetails: function (id,role,callbacks) {
        getSalesDashboardDetails(id,role,callbacks);
      },
      getIVRDetails: function (data,agentId,callbacks) {
        getIVRDetails(data,agentId,callbacks);
      },
      getOfferTransfer: function (offerId,callId,dId,callbacks) {
        getOfferTransfer(offerId,callId,dId,callbacks);
      },
      //added   
      getCallHistory: function (id,role,pageno,size,callbacks) {   
        getCallHistory(id,role,pageno,size,callbacks);   
      },
      getContactsPage: function (id,pageno,size,callbacks) {   
        getContactsPage(id,pageno,size,callbacks);   
      },
      getContactsDetailsView: function(phoneNumber,id,callbacks){
        getContactsDetailsView(phoneNumber,id,callbacks)
      }, 
      updateContactDetailsView:function(data, callbacks){
        updateContactDetailsView(data, callbacks)
      },
      getOfferDetailsFinal: function(id,callid,state,campaignid,callbacks){
        getOfferDetailsFinal(id,callid,state,campaignid,callbacks);
      },
      postAgentActions: function(data,optId,scriptId,callbacks){
        postAgentActions(data,optId,scriptId,callbacks);
      },
      //added-start   
      getForwardOfferData:function (data,optId,scriptId,callbacks) {    
        getForwardOfferData(data,optId,scriptId,callbacks);   
      },    
      postSelectedOfferFrwd:function(offerId,callId,callbacks){   
        postSelectedOfferFrwd(offerId,callId,callbacks);    
      },    
      //added-end
      //editscript-added-start
      saveSideQustns:function(data,callbacks){
        saveSideQustns(data,callbacks);
      },
      //editscript-added-end
      updateLeadField: function(data,callbacks){
        updateLeadField(data,callbacks);
      },
      postAgentStatusUpdate: function(data,userAgentId,role,callbacks){
        postAgentStatusUpdate(data,userAgentId,role,callbacks);
      },
      getStateCity : function(zipcode,callbacks){
        getStateCity(zipcode,callbacks)
      },
      //repeatedly hitting server to check net connectivity -start
      postConnectionDetails: function(userAgentId, role,callbacks){
        postConnectionDetails(userAgentId,role,callbacks);
      },
     ///repeatedly hitting server to check net connectivity -end
       getAgentStatus: function(userAgentId,role,callbacks){
        getAgentStatus(userAgentId,role,callbacks);
      },
      /*putAgentTransferStatus: function(userAgentId,callbacks){
        putAgentTransferStatus(userAgentId,callbacks);
      },*/
      postDispositions: function(callid,disposition,callbacks){
        postDispositions(callid,disposition,callbacks);
      },
      postsalesDispositions : function(callerid,id,root_disposition,selected_disposition,notes,callbacks){
        postsalesDispositions(callerid,id,root_disposition,selected_disposition,notes,callbacks);
      },
      postetlDispostionStatus : function(id,callerid,root_disposition,selected_disposition,callbacks){
        postetlDispostionStatus(id,callerid,root_disposition,selected_disposition,callbacks);
      },
      postetlOldDispostionStatus : function(id,callerid,old_status,root_disposition,selected_disposition,callbacks){
        postetlOldDispostionStatus(id,callerid,old_status,root_disposition,selected_disposition,callbacks);
      },
      postStaticQuestions: function(payload,callbacks){
        postStaticQuestions(payload,callbacks);
      },
      notesUpdate:function(phonenumber, id, notes, callbacks){
        notesUpdate(phonenumber, id, notes, callbacks);
      },
      putAgentTransferStatus: function(userAgentId,callId,callbacks){
        putAgentTransferStatus(userAgentId,callId,callbacks);
      },
      postAgentBusy: function(data,userAgentId,callbacks){
        postAgentBusy(data,userAgentId,callbacks);
      },
      postAgentAvailable: function(data,userAgentId,callbacks){
        postAgentAvailable(data,userAgentId,callbacks);
      },
      postUserDetails: function(data,callbacks){
        postUserDetails(data,callbacks);
      },
      getAlertsData: function (id,callbacks) {
        getAlertsData(id,callbacks);
      },
      putAlertsData: function (notificationAlert,emailAlert,callbacks){
        putAlertsData(notificationAlert,emailAlert,callbacks);
      },
      getCurrentUserData: function () {
        return currentUserData;
      },
        getCurrentServerDetails: function () {
            return currentServerDetails;
        },
      setCurrentUserData: function (userObj) {
        currentUserData = userObj;
      },
      getCheckingAuthWithServer: function(){
        return checkingAuthWithServer;
      },
      getCurrentUserAuthStatus: function(){
        return isUserAuthenticated;
      },
      updateUserPassword: function(id, data, callbacks){
        updateUserPassword(id, data, callbacks);
      },
      getEmailTemplate: function(id, callbacks){
        getEmailTemplate(id, callbacks);
      },
      checkUserSessionWithServer: function(){
        checkUserSessionWithServer();
      },
      updateUserAccount: function(id, data, callbacks){
        updateUserAccount(id, data, callbacks);
      },
      getEmailTemplatesData: function(callbacks){
        getEmailTemplatesData(callbacks);
      },
      updateEmailTemplateData: function(id, data, callbacks){
        updateEmailTemplateData(id, data, callbacks);
      },
      forgotPassword: function(data, callbacks){
        forgotPassword(data, callbacks);
      },
      login: function(credentials, callbacks){
        userSignIn(credentials, callbacks);
      },
      logout: function(token, callbacks){
        userLogout(token,callbacks);
      },
      getUSStates: function() {
        return $http.get("/wapi/states");
    },
    signupSalesAgent: function (data,callbacks) {
      signupSalesAgent(data,callbacks);
    },
    signupAgent: function (data, callbacks) {
      signupAgent(data, callbacks);
    },
    getAgencyByAgencyId: function (agencyId, callbacks) {
      getAgencyByAgencyId(agencyId,callbacks)
    },
    contactPageReportsData : function(filterscontact, callbacks){
      contactPageReportsData(filterscontact,callbacks);
    },
    callHistoryPageReportsData : function(filtershistory, callbacks){
      callHistoryPageReportsData(filtershistory,callbacks);
    },
    onEndCall : function(agentId, callbacks){
      onEndCall(agentId,callbacks);
    },
    stageDispositionSubmit : function(agentId, phone_number, rootDisposition, disposition, callbacks){
      stageDispositionSubmit(agentId, phone_number, rootDisposition, disposition, callbacks);
    },
    getCarrierDetails : function(callbacks){
      getCarrierDetails(callbacks);
    },
    getCarrierDetailsForFilters : function(callbacks){
      getCarrierDetailsForFilters(callbacks);
    },
    getAgentDetails : function(callbacks){
      getAgentDetails(callbacks);
    },
    getAgentDetailsForFilters : function(callbacks){
      getAgentDetailsForFilters(callbacks);
    },
    // getFilterAllAgentDetails : function(callbacks){
    //   getFilterAllAgentDetails(callbacks);
    // },
    getApplicationContactDetails : function(contactid,agentid,callbacks){
      getApplicationContactDetails(contactid,agentid,callbacks);
    },
    getApplicationDetails : function(agentid,page,size,callbacks){
      getApplicationDetails(agentid,page,size,callbacks);
    },
    createApplication : function(data,callbacks){
      createApplication(data,callbacks);
    },
    getProductsBasedOnCarrier : function(carrierid,callbacks){
      getProductsBasedOnCarrier(carrierid,callbacks);
    },
    getAllProducts : function(callbacks){
      getAllProducts(callbacks);
    },
    getAllProductsForFilters : function(callbacks){
      getAllProductsForFilters(callbacks);
    },
    updateSalesAgent: function (agentId,data, callbacks) {
      updateSalesAgent(agentId,data, callbacks);
    },
    getSalesAgents : function(id,callbacks){
      getSalesAgents(id,callbacks);
    },
    getAgentTimeZones: function (callbacks) {
      getAgentTimeZones(callbacks);
    },
    getUSStates: function() {
      return $http.get("/japi/us-states");
    },
    getSupportDetails : function(userId,page,size,callbacks){
      getSupportDetails(userId,page,size,callbacks);
    },
    createSupport : function(data,callbacks){
      createSupport(data,callbacks);
    },
    updateSupport : function(ticketId,data,callbacks){
      updateSupport(ticketId,data,callbacks);
    },
    updateSupportStatus : function(id,status,callbacks){
      updateSupportStatus(id,status,callbacks);
    },
   
    getSettingsRecords : function(salesagentid,callbacks){
      getSettingsRecords(salesagentid,callbacks);
    },
    settingAppRecord : function(salesagentid, locationid, action, callbacks){
      settingAppRecord(salesagentid, locationid, action, callbacks);
    },
    applicationPageReportsData : function(filtersapplications, callbacks){
      applicationPageReportsData(filtersapplications,callbacks);
    },
    exitImpersonation : function(role, callbacks){
      exitImpersonation(role,callbacks);
    }
    };
  }]);